import React, { useEffect, createContext, useState } from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import $axios from "./services/axios";
import { Modal } from "antd";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyTokenRaw =
    queryParams.get("VerifyToken") || queryParams.get("verifyToken");

  let verifyToken = verifyTokenRaw?.replace(/ /g, "+");
  const [token, setToken] = useState(() => {
    if (verifyToken) return null;
    const stored = localStorage.getItem("planeToken");
    if (stored) {
      try {
        const payloadBase64 = stored.split(".")[1];
        if (payloadBase64) {
          const payload = JSON.parse(
            atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/")),
          );
          if (payload.exp && payload.exp * 1000 < Date.now()) {
            localStorage.removeItem("planeToken");
            return null;
          }
        }
      } catch (e) {
        localStorage.removeItem("planeToken");
        return null;
      }
    }
    return stored;
  });
  const history = useHistory();
  const location = useLocation();

  // Helper: decode JWT payload and check expiration
  const isTokenExpired = (jwt) => {
    try {
      const payloadBase64 = jwt.split(".")[1];
      if (!payloadBase64) return true;
      const payload = JSON.parse(
        atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/")),
      );
      if (payload.exp && payload.exp * 1000 < Date.now()) return true;
      return false;
    } catch (e) {
      return true;
    }
  };

  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      if (verifyToken) {
        // Check if verifyToken is expired BEFORE calling backend
        // if (isTokenExpired(verifyToken)) {
        //   console.warn("[App] verifyToken đã hết hạn");
        //   modal.error({
        //     ...config,
        //     title: "Phiên đăng nhập đã hết hạn!",
        //     content:
        //       "Link truy cập đã hết hạn. Vui lòng quay về ứng dụng và lấy link mới.",
        //   });
        //   return;
        // }

        localStorage.removeItem("planeToken");
        const res = await $axios.$post(
          `${process.env.REACT_APP_BASE_URL}/v1/auth/login-mbfp`,
          {
            VerifyToken: verifyToken,
            TypeService: "flight",
          },
        );

        const accesstoken = res.data.data.accesstoken;

        // Check if returned accesstoken is also expired
        // if (isTokenExpired(accesstoken)) {
        //   console.warn("[App] accesstoken từ login-lichviet đã hết hạn");
        //   modal.error({
        //     ...config,
        //     title: "Phiên đăng nhập đã hết hạn!",
        //     content:
        //       "Token nhận được đã hết hạn. Vui lòng quay về ứng dụng và lấy link mới.",
        //   });
        //   return;
        // }

        localStorage.setItem("planeToken", accesstoken);
        const userInfo = res?.data?.data?.userinfo;
        if (userInfo) {
          userInfo.phone = userInfo?.phone?.replace(/^84/, "0");
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        }
        queryParams.delete("VerifyToken");
        queryParams.delete("verifyToken");
        setToken(accesstoken);
        history.replace({
          pathname: location.pathname,
          search: queryParams.toString(),
        });
      } else {
        if (!token) {
          verifyToken = process.env.REACT_APP_VERIFY_TOKEN;
          decodeToken();
          // modal.error(config);
        }
      }
    } catch (error) {
      modal.error(config);
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/vemaybay"} />
        <Route
          exact
          path={"/vemaybay"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Redirect to={"/vemaybay"} />
      </Switch>
      {contextHolder}
    </>
  );
};

export default App;
